/* eslint-disable no-useless-catch */
import api from '@/utils/api';
import { endpoints } from '@/utils/api';

export const filterCompanies = async (params = {}) => {
  const response = await api.get(endpoints.companiesFilter, {
    params: {
      page: params.page || 1,
      pageSize: params.pageSize || 999999, // Use very large number to get all companies
      search: params.search || '',
      role_id: params.role_id,
      role: params.role,
      ...params
    }
  });
  return response.data;
};
  export const setupCompanyProfile = async (payload) => {
   const isFormData = payload instanceof FormData;

  const config = {
    headers: {
      'Content-Type': isFormData ? 'multipart/form-data' : 'application/json'
    }
  };

  const response = await api.post(endpoints.setupCompanyProfile, payload, config);
  return response.data;
};

export const getCompanyBySlug = async (slug) => {
  const response = await api.get(`${endpoints.companyBySlug}/${slug}`);
  return response.data;
};

export const getCompanyById = async (id) => {
  const response = await api.get(`${endpoints.companyById}/${id}`);
  return response.data;
};

export const createCompany = async (companyData) => {
  const response = await api.post(endpoints.createCompany, companyData);
  return response.data;
};

export const updateCompany = async (id, companyData) => {
  try {
    const isFormData = companyData instanceof FormData;
    
    const config = {
      headers: {
        'Content-Type': isFormData ? 'multipart/form-data' : 'application/json'
      }
    };
    
    const response = await api.put(`${endpoints.updateCompany}/${id}`, companyData, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCompany = async (id) => {
  try {
    const response = await api.delete(`${endpoints.updateCompany}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCompany = async (id) => {
  try {
    const response = await api.get(`${endpoints.getCompany}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const saveForLater = async (companyId) => {
  try {
    const response = await api.post(`${endpoints.companies}/${companyId}/save-for-later`);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const removeFromSaved = async (companyId) => {
  try {
    const response = await api.delete(`${endpoints.companies}/${companyId}/save-for-later`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSavedForLater = async (userId) => {
  try {
    const response = await api.get(`${endpoints.companies}/saved-for-later/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const listCompanies = async (params = {}) => {
  const response = await api.get(endpoints.companies, { params });
  return response.data;
};

export const getChildCompaniesByParentId = async (parentCompanyId) => {
  const response = await api.get(`${endpoints.companies}/mapping/${parentCompanyId}`);
  return response.data;
};

export const getDMSCompany = async () => {
  const response = await api.get(endpoints.dmsCompany);
  return response.data;
};
